<template>

  <div>

    <div v-for="(group, key) in grouped" :key="key">

      <div class="toggles" data-style="default">

        <div class="toggle extra-color-1">

          <h3><a href="#" class="uppercase"><i class="icon-plus-sign"></i>{{ group.factorgroup }}</a></h3>

          <div class="hidden">
            <div class="wpb_text_column wpb_content_element">
              <div class="wpb_wrapper py-2">

                <table class="w-full" v-for="(name, key) in group.items" :key="key">
                  <tbody>
                    <tr>
                      <td class="w-1/2 accordion-td">{{ name.factorname }}</td>
                      <td class="w-1/2 accordion-td">
                        <div v-for="(item, key) in name.items" :key="key">
                          {{ item.factorvalue }}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>

              </div>
            </div>
          </div>

        </div>

      </div>

    </div>

  </div>

</template>

<script>

export default {

  name: 'VaRecordAccordion',

  props: {
    factors: { type: Array }
  },

  computed: {
    grouped () {
      return this.getGrouped();
    }
  },

  methods: {

    getGrouped() {

      let grouped = {};
      let factorgroupid = 0;
      let factornameid = 0;

      this.factors.forEach(factor => {

        factorgroupid = factor.factorgroupid || 0;
        factornameid  = factor.factornameid  || 0;

        grouped[factorgroupid] = grouped[factorgroupid] || {};
        grouped[factorgroupid]['factorgroupid'] = factorgroupid;
        grouped[factorgroupid]['factorgroup'] = factor.factorgroup;

        grouped[factorgroupid]['items'] = grouped[factorgroupid]['items'] || {};
        grouped[factorgroupid]['items'][factornameid] = grouped[factorgroupid]['items'][factornameid] || {};
        grouped[factorgroupid]['items'][factornameid]['factornameid'] = factornameid;
        grouped[factorgroupid]['items'][factornameid]['factorname'] = factor.factorname;

        grouped[factorgroupid]['items'][factornameid]['items'] = grouped[factorgroupid]['items'][factornameid]['items'] || [];
        grouped[factorgroupid]['items'][factornameid]['items'].push({
          'factorvalueid': factor.factorvalueid,
          'factorvalue'  : factor.factorvalue
        });

      });

      return grouped;
    }

  }

}
</script>
